import React from "react";

function ConfigureLabel(props) {
	let teste = props.label;
	if (teste) {
		if (props.length) {
			if (teste.length > props.length) {
				teste = teste.substr(0, props.length) + "...";
			}
		} else {
			if (teste.length > 50) {
				teste = teste.substr(0, 50) + "...";
			}
		}
	}
	return <span>{teste}</span>;
}

export default ConfigureLabel;
